export default __webpack_public_path__ + "static/media/Сlose_square_line.cd14d727.svg";